import ApplicationAdapter from 'lumen/adapters/application';

export default class ParityConfigAdapter extends ApplicationAdapter {
  buildURL(...args: Parameters<ApplicationAdapter['buildURL']>): string {
    // Can't use inflector rule because (1) path name is dynamic and (2) other config models are affected
    // Can't use urlForQuery because requestType='queryRecord' isn't passed in application adapter
    const url = super.buildURL(...args);
    return url.replace('/configs', '/config');
  }
}
